export const defaultEntity = "prenotazioni";
export const entities = ["prenotazioni"];
export const labels = {
  prenotazioni: "Prenotazioni",
};
